import { render, staticRenderFns } from "./SiteSuspend.vue?vue&type=template&id=a076944e&scoped=true"
import script from "./SiteSuspend.vue?vue&type=script&lang=js"
export * from "./SiteSuspend.vue?vue&type=script&lang=js"
import style0 from "./SiteSuspend.vue?vue&type=style&index=0&id=a076944e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a076944e",
  null
  
)

export default component.exports